import { PARTNER_TYPES } from '../../partner-types';
import { MenuItem } from '../types';

// Note: the former "Settings" section (API Credentials, UI Customization,
// Data Validation, Fraud Rules) lives in `./integration-and-settings.ts` as
// `integrationSettingsSection`. This file now only hosts Support & Feedback
// and Portal Information.

// Support & Feedback
export const supportFeedbackSection: MenuItem[] = [
  {
    headTitle1: 'Support & Feedback',
    type: 'headtitle',
  },
  {
    title: 'Requests',
    icon: 'stroke-feedback',
    iconf: 'fill-feedback',
    type: 'sub',
    active: false,
    children: [
      {
        path: '/support-and-feedback/requests/submit',
        title: 'Submit Request',
        type: 'link',
        active: false,
      },
      {
        path: '/support-and-feedback/requests',
        title: 'My Requests',
        type: 'link',
        active: false,
      },
    ],
  },
];

// Portal Information
export const portalInformationSection: MenuItem[] = [
  {
    headTitle1: 'Portal Information',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER],
  },
  {
    path: '/portal-changelog',
    title: 'Portal Changelog',
    icon: 'stroke-faq',
    iconf: 'fill-faq',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER],
  },
  {
    path: '/sitemap',
    title: 'Portal Sitemap',
    icon: 'stroke-sitemap',
    iconf: 'fill-sitemap',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER],
  },
];
